module.exports = __webpack_public_path__ + "static/media/img_delcielo.f24e3a63.jpg";